import { createTheme } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core";
const theme = createTheme({
    typography: {
        fontFamily: ["monstserrat"].join(',')
    }
})

export default theme;